<div class="license-section"
        [class.exclusive-licensed]="CurrentLicenseData && (CurrentLicenseData?.cartData?.beat_price?.licence?.slug === 'exclusive')"
        [class.wam-licensed]="CurrentLicenseData && (CurrentLicenseData?.cartData?.beat_price?.licence?.slug === 'wav' || CurrentLicenseData?.cartData?.sound_price?.licence?.slug === 'wav' || CurrentLicenseData?.contentType === 'sound')"
        [class.WAV-STEMS-licensed]="CurrentLicenseData && CurrentLicenseData?.cartData?.beat_price?.licence?.slug === 'wav_stem'"
        [class.is-sound-kit]="CurrentLicenseData?.contentType === 'sound' || CurrentLicenseData?.cartData?.sound_price">
    <div class="ipm-close-icon" (click)="close()">
        <i class="pi pi-times"></i>
    </div>
    <div class="license-heading ipm-container">
         <ng-container *ngIf="CurrentLicenseData?.contentType === 'sound' || CurrentLicenseData?.cartData?.sound_price">Sound Kit (Non-Exclusive)</ng-container>
         <ng-container *ngIf="CurrentLicenseData?.contentType !== 'sound' && !CurrentLicenseData?.cartData?.sound_price">{{CurrentLicenseData && CurrentLicenseData?.cartData?.beat_price?.licence?.slug === 'wav_stem' ? 'Wav + Stems' : CurrentLicenseData?.license}}</ng-container>
         &nbsp;<span class="pl-2">License Agreement</span>
    </div>
    <div class="license-body ipm-container">
        <ng-container *ngIf="CurrentLicenseData && CurrentLicenseData?.cartData?.beat_price?.licence?.slug === 'exclusive'">
            <ipm-license-exclusive [CurrentLicenseData]="CurrentLicenseData"></ipm-license-exclusive>
        </ng-container>
        <!-- Beat WAV License -->
        <ng-container *ngIf="CurrentLicenseData && CurrentLicenseData?.cartData?.beat_price?.licence?.slug === 'wav' && CurrentLicenseData?.contentType !== 'sound'">
            <ipm-license-wav [CurrentLicenseData]="CurrentLicenseData" ></ipm-license-wav>
        </ng-container>
        <!-- Sound WAV License -->
        <ng-container *ngIf="CurrentLicenseData && (CurrentLicenseData?.cartData?.sound_price?.licence?.slug === 'wav' || CurrentLicenseData?.contentType === 'sound')">
            <ipm-license-wav-sound [CurrentLicenseData]="CurrentLicenseData"></ipm-license-wav-sound>
        </ng-container>
        <ng-container *ngIf="CurrentLicenseData && CurrentLicenseData?.cartData?.beat_price?.licence?.slug === 'wav_stem'">
            <ipm-license-wav-stems [CurrentLicenseData]="CurrentLicenseData"></ipm-license-wav-stems>
        </ng-container>

        <!-- Beat MP3 license -->
        <ng-container *ngIf="CurrentLicenseData && CurrentLicenseData?.cartData?.beat_price?.licence?.slug === 'mp3'">
            <ipm-mp3-license [CurrentLicenseData]="CurrentLicenseData"></ipm-mp3-license>
        </ng-container>
    </div>
</div>
